import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ds-product-card__inner" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "ds-product-card-tag ds-product-card-tag--add-favorites ds-product-card__left-placeholder authenticated"
}
const _hoisted_4 = { class: "ds-product-card-tag ds-product-card-tag--scratch ds-product-card__right-placeholder" }
const _hoisted_5 = { class: "ds-product-card-tag__wrapper ds-product-card-tag__text" }
const _hoisted_6 = { class: "ds-product-card__text-wrap" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["href", "data-game-id", "data-game-code", "data-price", "data-prize", "data-transparent"]

import { TicketPromoCard } from "@/tickets/models/ticket-promo-card";
import { WebpHelper } from "@sazka/utils/webp-helper";
import { StringUtils } from "@sazka/utils/string-utils";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import { computed } from "vue";
import { useFavoriteTicketsStore } from "../favorite-tickets-store";


export default /*@__PURE__*/_defineComponent({
  __name: 'ticket-promo-card',
  props: {
    card: {}
  },
  setup(__props: any) {

const props = __props;

const store = useFavoriteTicketsStore();
const isFavorite = computed(() => store.isFavoriteTicket(props.card.externalSystemID));
const toggleFavorite = () => store.toggleFavoriteTicket(props.card.externalSystemID);

const prizeText = computed(() =>
    props.card.teaserPriceText ? props.card.teaserPriceText : StringUtils.formatCurrency(props.card.prize)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ds-product-card ds-product-card--portrait", [
            _ctx.card.isOnline ? 'ds-product-card--eticket' : 'ds-product-card--ticket',
            { authenticated: _ctx.card.hideForNotLoggedUsers },
        ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        innerHTML: 
                    _unref(WebpHelper).createPictureTag(_ctx.card.teaserImageUrl, `${_ctx.card.name} - obrázek`, 'ds-product-card__img')
                
      }, null, 8, _hoisted_2),
      _cache[2] || (_cache[2] = _createElementVNode("em", { class: "ds-product-card__gradient" }, null, -1)),
      (_ctx.card.isOnline)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: _normalizeClass(["ds-product-card-tag__button ds-product-card-tag__button--add-favorites", { 'ds-product-card-tag__button--active': isFavorite.value }]),
              "data-js-hook": "ds-product-card-add-favorites"
            }, [
              _createVNode(DsIcon, {
                onClick: toggleFavorite,
                name: "favorite-star-active",
                width: 16,
                height: 16
              })
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          class: "ds-product-card-tag__img",
          src: "/frontend/web/img/scrappers/scratch.svg",
          height: "39",
          width: "60",
          alt: ""
        }, null, -1)),
        _createElementVNode("span", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.card.roundPrice) + " ", 1),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ds-product-card-tag__currency" }, "Kč", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h3", {
          class: "ds-product-card__title",
          innerHTML: _ctx.card.name
        }, null, 8, _hoisted_7),
        _createElementVNode("span", {
          class: "ds-product-card__sub-text",
          innerHTML: _ctx.card.teaserText
        }, null, 8, _hoisted_8),
        _createElementVNode("span", {
          class: "ds-product-card__price",
          innerHTML: prizeText.value
        }, null, 8, _hoisted_9)
      ]),
      _createElementVNode("a", {
        href: _ctx.card.pageUrl.relative,
        class: _normalizeClass(["ds-product-card__link", { 'game-launcher': _ctx.card.isOnline }]),
        "data-game-id": _ctx.card.externalSystemID,
        "data-game-code": _ctx.card.codeName,
        "data-price": _ctx.card.roundPrice,
        "data-prize": _ctx.card.prizeFilter ? _ctx.card.prizeFilter : _ctx.card.prize,
        "data-transparent": _ctx.card.isTransparent
      }, null, 10, _hoisted_10)
    ])
  ], 2))
}
}

})